module.exports = __webpack_public_path__ + "static/media/logistic.057430d9.png";